(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["size-table"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const ACTIVE_CLASS = 'is-active';
    const CM_TO_INCH = 0.393701;
    const UNIT_SELECTOR = '[data-unit]';

    document.querySelectorAll('.size-table').forEach((root) => {
      const buttons = root.querySelectorAll(UNIT_SELECTOR);
      // A <td> that only wraps <span data-cm> is a container, not a value.
      const cells = [...root.querySelectorAll('[data-cm]')].filter((el) => !el.querySelector('[data-cm]'));
      if (!buttons.length || !cells.length) return;

      const render = (unit) => {
        cells.forEach((el) => {
          // The printed value may differ from the attribute ("15,5" vs "15.5").
          if (el.dataset.cmText === undefined) el.dataset.cmText = el.textContent;
          el.textContent = unit === 'inch' ? (parseFloat(el.dataset.cm) * CM_TO_INCH).toFixed(1) : el.dataset.cmText;
        });

        buttons.forEach((btn) => {
          const on = btn.dataset.unit === unit;
          btn.classList.toggle(ACTIVE_CLASS, on);
          btn.setAttribute('aria-pressed', String(on));
        });
      };

      buttons.forEach((btn) => btn.addEventListener('click', () => render(btn.dataset.unit)));
      render('cm');
    });
  });
  } catch(e) { console.error(e); }
})();

})();
